export enum COMPARE_MENU_EVENTS {
  COMPARE_CLEAR = `[Lift] Compare Menu Clear`,
  COMPARE_SELECTION = `[Lift] Compare Menu Selection`,
}

export const compareMenuEvents = new Set([COMPARE_MENU_EVENTS.COMPARE_CLEAR, COMPARE_MENU_EVENTS.COMPARE_SELECTION]);

export enum COMPARE_MENU_PROPNAMES {
  PREVIOUS_STATE = `Previous state`,
  COMPARE_TYPE = `Compare type`,
}
